<template>
    <div class="wish-list">
        <list :fs="wishlistFields" api="wishlists" apiList="wishlists/my" :showAction="false"></list>
    </div>
</template>

<script>
import List from "@/components/List";
import CartButtons from "@/components/Cart/CartButtons";
import { wishlistFields } from "@/config";

export default {
    components: {
        List
    },
    data() {
        return {};
    },
    computed: {
        wishlistFields() {
            return wishlistFields;
        }
    },
    methods: {},

    created() {}
};
</script>
<style style="lang">
</style>
